import angular from 'angular';
import ajaxSpinnerInterceptor from './ajaxSpinnerInterceptor';
import spinOnAjaxDirective from './spinOnAjaxDirective';
import spinWhenDirective from './spinWhenDirective';
import spinOnNavigateDirective from './spinOnNavigateDirective';
import './spinnerStyles.css';

angular
	.module('sh.spinner', [])
	.directive('shSpinOnNavigate', spinOnNavigateDirective)
	.directive('shSpinOnAjax', spinOnAjaxDirective)
	.directive('shSpinWhen', spinWhenDirective)
	.config(ajaxSpinnerInterceptor);
